// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3RfiR","buttons":"RemoveExpirationActionButtons_buttons__1pDUf"};